/**
 * Validates a remembered/templated account id against the loaded accounts
 * list. Returns the id if it resolves to a selectable account, "" otherwise.
 *
 * Guards against a stale localStorage `aim-last-account-id` (account archived
 * since, or another user's id on a shared device): without this the select
 * renders like "No account" while the hidden state would still POST the id —
 * the archived case even passes ownership and silently links the entry to an
 * invisible account.
 */
export function reconcileAccountId(
  accountId: string,
  accounts: ReadonlyArray<{ id: string }>,
): string {
  if (!accountId) return "";
  return accounts.some((a) => a.id === accountId) ? accountId : "";
}
